import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ActionBar,
  ActionBarItem,
  Column,
  confirm,
  createAllItemCountSelector,
  createListErrorSelector,
  createListSelector,
  DetailPanel,
  FilterCombo,
  FilterObject,
  List,
  load,
  Protected,
  Pagination,
  translate,
  remove,
  Link
} from "clavis-nxt-components-custdevtm";
import "./ConfigurationKeys.scss";
import { ConfigurationEntity } from "./domain/ConfigurationEntity/ConfigurationEntity";
import { AddOrModifyModal } from "./components/AddOrModifyModal/AddOrModifyModal";
import { ConfigurationModal } from "./components/ConfigurationModal/ConfigurationModal";
import _ from "lodash";

class ConfigurationKeysComponent extends Component {
  static displayName = "Configuration Key Page";

  constructor(props) {
    super(props);
    this.state = {
      actualPage: 1,
      criteriaList: [],
      entity: null,
      filterComboLimit: 3,
      filterComboWarning: "",
      firstItem: 0,
      isOpenAddOrModify: false,
      isOpenConfiguration: false,
      numberOfItemsPerPage: 10,
      sortBy: "id",
      sortDirection: "asc",
      advancedSearchFilter: new FilterObject(
        ConfigurationEntity,
        "ConfigurationEntityFilter"
      )
    };
  }

  componentDidMount() {
    this.loadAllConfigurations();
  }

  deleteEntity = entity => {
    this.props.remove(entity).promise.then(() => {
      this.loadAllConfigurations();
    });
  };

  DetailPanelContainer = props => {
    const { t } = this.props;

    return (
      <DetailPanel
        container={"configuration-list"}
        direction={"bottom"}
        offSet={"-75px"}
        uniqueKey={"configuration-detail" + props.entity.id}
      >
        <div className={"configuration-details"}>
          {/*<Protected privilege={"ptf_swift_admin_modify"}>*/}
          {/*  <Link*/}
          {/*    className={"edit-label-color-warning"}*/}
          {/*    click={() =>*/}
          {/*      this.createConfirmAction(() => {*/}
          {/*        this.deleteEntity(props.entity);*/}
          {/*      }, t("components.ConfirmModal.Delete"))()*/}
          {/*    }*/}
          {/*  >*/}
          {/*    {t("page.configurationPage.delete")}*/}
          {/*  </Link>*/}
          {/*</Protected>*/}
          <Protected privilege={"ui_ptf_configuration_keys_modify"}>
            <Link click={() => this.toggle("isOpenAddOrModify", props.entity)}>
              {t("page.configurationPage.modify")}
            </Link>
          </Protected>
          {/*<Protected privilege={"ptf_swift_admin_modify"}>*/}
          {/*  <Link*/}
          {/*    click={() =>*/}
          {/*      this.toggle(*/}
          {/*        "isOpenConfiguration",*/}
          {/*        props.entity,*/}
          {/*        false,*/}
          {/*        "environment"*/}
          {/*      )*/}
          {/*    }*/}
          {/*  >*/}
          {/*    {t("page.configurationPage.configurationEnvironment")}*/}
          {/*  </Link>*/}
          {/*</Protected>*/}
          {/*<Protected privilege={"ptf_swift_admin_modify"}>*/}
          {/*  <Link*/}
          {/*    click={() => this.toggle("isOpenConfiguration", props.entity)}*/}
          {/*  >*/}
          {/*    {t("page.configurationPage.configurationLocal")}*/}
          {/*  </Link>*/}
          {/*</Protected>*/}
        </div>
      </DetailPanel>
    );
  };

  getCriteria = criteriaList => {
    const { t } = this.props;
    if (criteriaList.length > this.state.filterComboLimit) {
      this.setState({
        filterComboWarning: t("components.FilterCombo.Warning")
      });
    } else {
      this.setState(
        {
          criteriaList: criteriaList,
          filterComboWarning: ""
        },
        this.loadAllConfigurations
      );
    }
  };

  loadAllConfigurations = () => {
    let filterObject = null;
    if (this.state.advancedSearchFilter.criteria.length !== 0) {
      filterObject = _.cloneDeep(this.state.advancedSearchFilter);
    } else {
      filterObject = new FilterObject(
        ConfigurationEntity,
        "ConfigurationEntityFilter"
      );
    }

    this.state.criteriaList.forEach(criteria => {
      filterObject.add(criteria);
    });

    filterObject.addPaging(
      this.state.firstItem,
      this.state.numberOfItemsPerPage
    );

    filterObject.addSorting(this.state.sortBy, this.state.sortDirection);

    this.props.loadAll(filterObject);
  };

  toggle = (isOpenKey, entity = null, refresh = false, type = "local") => {
    this.setState(
      {
        entity: entity,
        type: type
      },
      () => {
        this.setState(prevState => ({
          [isOpenKey]: !prevState[isOpenKey]
        }));

        if (refresh) {
          this.loadAllConfigurations();
        }
      }
    );
  };

  selectListPage = (page, firstItem) => {
    this.setState(
      {
        firstItem: firstItem,
        actualPage: page
      },
      this.loadAllConfigurations
    );
  };

  sortByCallback = headerProp => {
    let sortBy = headerProp;
    let sortDirection = "asc";
    if (this.state.sortBy === headerProp) {
      sortDirection = this.state.sortDirection === "asc" ? "desc" : "asc";
    }
    this.setState(
      { sortBy: sortBy, sortDirection: sortDirection },
      this.loadAllConfigurations
    );
  };

  render() {
    const { t } = this.props;
    return (
      /*      <div className="swift-admin">
                    <CRUDComponent
                      entityType={ConfigurationEntity}
                      addPrivilege={"ptf_swift_admin_modify"}
                      removePrivilege={"ptf_swift_admin_modify"}
                      modifyPrivilege={"ptf_swift_admin_modify"}
                    />
                  </div>*/
      <div className={"configuration-page"}>
        <div className={"header-container"}>
          {/*<ActionBar>*/}
          {/*  <Protected privilege={"ptf_swift_admin_modify"}>*/}
          {/*    <ActionBarItem*/}
          {/*      icon={"icon-addnew interaction-color"}*/}
          {/*      labelColor={"interaction-color"}*/}
          {/*      labelRight={t("page.configurationPage.addConfiguration")}*/}
          {/*      onClick={() => this.toggle("isOpenAddOrModify")}*/}
          {/*    />*/}
          {/*  </Protected>*/}
          {/*</ActionBar>*/}
          <FilterCombo
            criteriaList={this.state.criteriaList}
            dropDownDefaultValue
            entitySortDirection
            entityType={ConfigurationEntity}
            filteredProps={[
              "id",
              "confKey",
              "confValue",
              "confDesc",
              "moduleCode"
            ]}
            filterOnEnter
            limit={this.state.filterComboLimit}
            onChange={this.getCriteria}
            scrollItemList
            warning={this.state.filterComboWarning}
            advancedSearchFilter={this.state.advancedSearchFilter}
            advancedSearchFilterCallback={newFilter => {
              this.setState(
                {
                  actualPage: 1,
                  advancedSearchFilter: newFilter,
                  firstItem: 0
                },
                () => this.getCriteria([])
              );
            }}
          />
        </div>
        <div className={"content"}>
          <div className={"title-bar"}>
            <div className={"header-color huge-font-medium title"}>
              {t("page.configurationPage.title")}
            </div>
            <div className={"refresh"}>
              <ActionBar>
                <ActionBarItem
                  icon={"icon-refresh interaction-color"}
                  iconSize={"icon-small"}
                  labelColor={"interaction-color"}
                  onClick={this.loadAllConfigurations}
                />
              </ActionBar>
            </div>
          </div>
          <div className={"list-container"}>
            <List
              compactView
              entities={this.props.configurationEntities}
              id={"configuration-list"}
              sortBy={this.state.sortBy}
              sortByCallback={this.sortByCallback}
              sortDirection={this.state.sortDirection}
              hasErrorFromServer={this.props.createListErrorSelector}
              markHoveredRow
            >
              <Column
                propName={"id"}
                sortable
                title={t("entity.ConfigurationEntity.property.id")}
              />
              <Column
                propName={"confKey"}
                sortable
                title={t("entity.ConfigurationEntity.property.confKey")}
              />
              <Column
                propName={"confValue"}
                sortable
                title={t("entity.ConfigurationEntity.property.confValue")}
              />
              <Column
                propName={"confDesc"}
                sortable
                title={t("entity.ConfigurationEntity.property.confDesc")}
              />
              <Column
                propName={"moduleCode"}
                sortable
                title={t("entity.ConfigurationEntity.property.moduleCode")}
              />
              <Column fixCol={true} title="">
                <this.DetailPanelContainer />
              </Column>
            </List>
            <Pagination
              allItems={this.props.configurationAllItemCount}
              numberOfItemsPerPage={this.state.numberOfItemsPerPage}
              selectedPage={this.state.actualPage}
              selectPageFunc={this.selectListPage}
            />
          </div>
        </div>
        {this.state.isOpenAddOrModify && (
          <AddOrModifyModal
            entity={this.state.entity}
            isOpen={this.state.isOpenAddOrModify}
            toggle={this.toggle}
          />
        )}
        {this.state.isOpenConfiguration && (
          <ConfigurationModal
            entity={this.state.entity}
            isOpen={this.state.isOpenConfiguration}
            toggle={this.toggle}
            type={this.state.type}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadAll: filterObject => dispatch(load(filterObject)),
  remove: entity => dispatch(remove(entity))
});

const mapStateToProps = (state, props) => {
  return {
    configurationAllItemCount: createAllItemCountSelector(
      ConfigurationEntity,
      "ConfigurationEntityFilter"
    )(state, props),
    configurationEntities: createListSelector(
      ConfigurationEntity,
      "ConfigurationEntityFilter"
    )(state, props),
    createListErrorSelector: createListErrorSelector(
      ConfigurationEntity,
      "ConfigurationEntityFilter"
    )(state, props)
  };
};

export const ConfigurationKeysPage = translate()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(confirm(ConfigurationKeysComponent))
);
